namespace JupitersChoice {
    export class HideBaseGameCmd {

        @inject('LayerManager') _layerManager: Sapphire.LayerManager;

        execute(): void {
            this._layerManager.setVisibility('BaseGame', false);
        }
    }
}